<template>
    <div class="section">
        <app-table></app-table>
    </div>
</template>

<script>
    import BidsTable from './BidsTable'
    export default {
        components: {
            appTable: BidsTable,
        }
    }
</script>

<style scoped>
    .section {
        margin-top: 25px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Bids/BidsList.vue